<template>
  <footer class="footer">
    <div class="container">
      <!-- Sections principales -->
      <div class="footer-sections">
        <!-- À propos -->
        <div class="footer-section footer-about">
          <div class="footer-logo">
            <img src="@/assets/logo.png" alt="patrimonea by Gwem" class="footer-logo__img" />
          </div>
          <p class="about-description">
            Les informations de cette plateforme ne constituent ni un conseil bancaire, juridique ou fiscal personnalisé.
            Toute décision d’investissement doit tenir compte de votre situation et, le cas échéant, d’un échange avec un conseiller.
          </p>
          <div class="social-links">
            <a href="#" class="social-link" aria-label="LinkedIn">
              <i class="fab fa-linkedin"></i>
            </a>
            <a href="#" class="social-link" aria-label="Twitter">
              <i class="fab fa-twitter"></i>
            </a>
            <a href="#" class="social-link" aria-label="Facebook">
              <i class="fab fa-facebook"></i>
            </a>
          </div>
        </div>

        <!-- Liens rapides -->
        <div class="footer-section footer-links">
          <h5 class="section-title">Liens Rapides</h5>
          <ul class="links-list">
            <li><RouterLink to="/" class="footer-link">Accueil</RouterLink></li>
            <li><RouterLink to="/approche" class="footer-link">Notre Approche</RouterLink></li>
            <li><RouterLink to="/platforme" class="footer-link">Plateforme</RouterLink></li>
            <li><RouterLink to="/nous-contacter" class="footer-link">Nous contacter</RouterLink></li>
          </ul>
        </div>

        <!-- Contact -->
        <div class="footer-section footer-contact">
          <h4 class="section-title">Nous Contacter</h4>
          <div class="contact-info">
            <div class="contact-item">
              <div class="contact-icon">
                <i class="fas fa-phone"></i>
              </div>
              <div class="contact-text">
                <a href="tel:+2250554191919" class="contact-link">+225 05 54 19 19 19</a>
              </div>
            </div> 
            <div class="contact-item">
              <div class="contact-icon">
                <i class="fas fa-phone"></i>
              </div>
              <div class="contact-text">
                <a href="tel:+2250712001200" class="contact-link">+225 07 12 00 12 00</a>
              </div>
            </div>
            <div class="contact-item">
              <div class="contact-icon">
                <i class="fas fa-envelope"></i>
              </div>
              <div class="contact-text">
                <a href="mailto:contact@patrimoneabygwem.com" class="contact-link">
                  contact@patrimoneabygwem.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="footer-bottom-content">
          <p class="copyright">
            © <span class="copyright-year">2026</span>
            <a
              href="https://www.patrimoneabygwem.com/"
              target="_blank"
              rel="noopener noreferrer"
              class="company-link"
            >
              patrimonea by Gwem
            </a>
            – Tous droits réservés.
          </p>
          <div class="legal-links">
            <RouterLink to="#" class="legal-link">Mentions légales</RouterLink>
            <RouterLink to="/politique-de-confidentialite" class="legal-link">Politique de confidentialité</RouterLink>
            <RouterLink to="/conditions-generales-utilisation" class="legal-link">Conditions d'utilisation</RouterLink>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
};
</script>

<style scoped>
.footer {
  background: linear-gradient(
    165deg,
    var(--bank-navy) 0%,
    var(--bank-primary-light) 42%,
    var(--bank-primary-dark) 100%
  );
  color: var(--bank-white);
  padding: var(--spacing-2xl) 0 var(--spacing-xl);
  position: relative;
  overflow: hidden;
  overflow-x: clip;
  font-family: var(--font-body);
}

.footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    var(--brand-brown) 18%,
    var(--brand-gold) 50%,
    var(--brand-brown) 82%,
    transparent 100%
  );
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-lg);
  position: relative;
  z-index: 1;
}

/* Sections principales */
.footer-sections {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 40px;
  margin-bottom: 40px;
}

.footer-section {
  padding: 0;
  text-align: left;
}

/* À propos */
.footer-logo {
  margin-bottom: var(--space-4);
  display: flex;
  justify-content: flex-start;
}

.footer-logo__img {
  width: clamp(140px, 18vw, 200px);
  height: auto;
  display: block;
  padding: 0;
  border-radius: 0;
  box-shadow: none;
  background: transparent;
  filter: brightness(0) invert(1);
}

.footer-logo__img:hover {
  opacity: 0.9;
}

.about-description {
  color: color-mix(in srgb, var(--paper) 82%, transparent);
  line-height: 1.65;
  margin: 0 0 var(--space-5);
  font-size: 0.875rem;
  max-width: 28rem;
  text-align: left;
}

.social-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: var(--space-3);
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: color-mix(in srgb, var(--bank-white) 9%, transparent);
  border: 1px solid color-mix(in srgb, var(--bank-gold) 28%, transparent);
  border-radius: 50%;
  color: var(--bank-white);
  text-decoration: none;
  transition: background 0.25s ease, border-color 0.25s ease, transform 0.25s ease, color 0.25s ease;
}

.social-link:hover {
  background: color-mix(in srgb, var(--bank-gold) 22%, transparent);
  border-color: var(--bank-gold);
  color: var(--bank-white);
  transform: translateY(-3px);
}

.footer .section-title {
  color: var(--paper);
  font-size: 1.0625rem;
  font-weight: 600;
  font-family: var(--font-body);
  letter-spacing: 0.02em;
  margin-bottom: var(--space-4);
  padding-bottom: var(--space-3);
  border-bottom: 1px solid rgba(255, 255, 255, 0.14);
  position: relative;
  text-align: left;
}

.footer .section-title::after {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 40px;
  height: 2px;
  background: var(--brand-brown);
}

/* Liens */
.links-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.links-list li {
  margin-bottom: 10px;
}

.footer-link {
  color: var(--bank-white);
  text-decoration: none;
  font-size: var(--text-sm);
  padding: 5px 0;
  position: relative;
  transition: color 0.25s ease, transform 0.25s ease;
  display: inline-block;
}

.footer-link::before {
  content: '›';
  color: var(--bank-gold);
  margin-right: 8px;
  opacity: 0;
  transform: translateX(-10px);
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.footer-link:hover {
  color: var(--bank-gold-light);
  transform: translateX(5px);
}

.footer-link:hover::before {
  opacity: 1;
  transform: translateX(0);
}

/* Contact */
.contact-info {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.contact-icon {
  color: var(--brand-brown);
  font-size: 1rem;
  min-width: 20px;
  padding-top: 2px;
}

.contact-icon i {
  color: var(--bank-gold);
}

.contact-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.contact-link {
  color: var(--bank-white);
  text-decoration: none;
  transition: color 0.25s ease;
  font-size: var(--text-sm);
  line-height: var(--line-snug);
  overflow-wrap: anywhere;
  word-break: break-word;
}

.contact-link:hover {
  color: var(--bank-gold-light);
}

.contact-text span {
  color: var(--bank-white);
  font-size: var(--text-sm);
  line-height: var(--line-snug);
}

/* Bas de footer */
.footer-bottom {
  border-top: 1px solid color-mix(in srgb, var(--bank-white) 12%, transparent);
  padding-top: var(--spacing-lg);
  margin-top: var(--spacing-xl);
}

.footer-bottom-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-4);
}

.footer-section.footer-links {
  padding: 0;
  text-align: left;
}

.copyright {
  color: color-mix(in srgb, var(--paper) 80%, transparent);
  font-size: 0.8125rem;
  text-align: left;
  margin: 0;
}

.copyright-year {
  display: inline;
  margin-right: 6px;
}

.company-link {
  color: var(--bank-gold-light);
  text-decoration: none;
  font-weight: var(--font-weight-semibold);
  transition: color 0.25s ease;
}

.company-link:hover {
  color: var(--bank-white);
  text-decoration: underline;
}

.legal-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
}

.legal-link {
  color: color-mix(in srgb, var(--bank-white) 92%, transparent);
  text-decoration: none;
  font-size: var(--text-xs);
  transition: color 0.25s ease;
  position: relative;
}

.legal-link:hover {
  color: var(--bank-gold-light);
}

.legal-link:not(:last-child)::after {
  content: '•';
  position: absolute;
  right: -12px;
  color: color-mix(in srgb, var(--bank-white) 28%, transparent);
}

/* Responsive */
@media (max-width: 992px) {
  .footer-sections {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 40px 0 20px;
  }
  
  .footer-sections {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .footer-section {
    padding: 0;
  }
  
  .footer-bottom-content {
    text-align: center;
  }
  
  .legal-links {
    flex-direction: column;
    gap: 10px;
  }
  
  .legal-link:not(:last-child)::after {
    display: none;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 0 15px;
  }
  
  .footer .section-title {
    font-size: 1rem;
  }
  
  .footer-section.footer-links .footer-link,
.contact-link,
.contact-text span {
    font-size: var(--text-xs);
  }

  .social-link {
    width: 44px;
    height: 44px;
  }
}
</style>
